import { connect } from 'react-redux';
import { getResourceApiKeys } from '../../../../lib/ResourceUtils';

import WebhookSourceConfiguration from './WebhookSourceConfiguration';

const mapStateToProps = (state, ownProps) => {
  const {
    entities: { sinks, apiKeys },
  } = state;

  const { data } = ownProps;

  const sourceApiKeys = getResourceApiKeys(data, apiKeys);

  const sink = data.data_sink ? sinks[data.data_sink] : null;

  return {
    apiKeys: sourceApiKeys,
    sink,
  };
};

export default connect(mapStateToProps, {})(WebhookSourceConfiguration);
